/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdphilosophie13Inputs */

const en__field_enum_sdphilosophie13 = /** @type {(inputs: _Field_Enum_Sdphilosophie13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`08 - Philosophie und Geschichtswissenschaften`)
};

const de__field_enum_sdphilosophie13 = /** @type {(inputs: _Field_Enum_Sdphilosophie13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`08 - Philosophie und Geschichtswissenschaften`)
};

/**
* | output |
* | --- |
* | "08 - Philosophie und Geschichtswissenschaften" |
*
* @param {_Field_Enum_Sdphilosophie13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdphilosophie13 = /** @type {((inputs?: _Field_Enum_Sdphilosophie13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdphilosophie13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdphilosophie13(inputs)
	return de__field_enum_sdphilosophie13(inputs)
});
export { _field_enum_sdphilosophie13 as "_field_enum_SDPHILOSOPHIE" }